import React from 'react';
import ReactDOM from 'react-dom/client';
// Bundled rather than fetched from Google Fonts: webpack fingerprints these
// and the service worker precaches them, so the app is styled offline.
//
// Latin and latin-ext only, at the three weights the theme uses. latin-ext
// earns its 36 kB on book titles with European accents; vietnamese does not.
import '@fontsource/space-grotesk/latin-400.css';
import '@fontsource/space-grotesk/latin-500.css';
import '@fontsource/space-grotesk/latin-700.css';
import '@fontsource/space-grotesk/latin-ext-400.css';
import '@fontsource/space-grotesk/latin-ext-500.css';
import '@fontsource/space-grotesk/latin-ext-700.css';
import './index.css';
import App from './App';
import axios from 'axios';
import ConfigProvider from './ConfigProvider';
import OfflineProvider from './OfflineProvider';
import { installConnectivityProbe } from './utils/offline/connectivity';

// Every API call reports whether the server answered, so "offline" reflects
// reachability rather than whether a network interface happens to be up.
installConnectivityProbe(axios);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider>
      <OfflineProvider>
        <App />
      </OfflineProvider>
    </ConfigProvider>
  </React.StrictMode>
);
